import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import MapPin from '@svg/contatti/map-pin.svg';
import styles from './tooltip-content.module.css';

const TooltipContent = ({ indirizzo, cap, phone, email, onBlur, onMouseLeave }) => {
  return (
    <div
      className={`${
        styles.tooltipContainer
      } text-center p-2 bg-white snf-text-color-prussian-blue d-flex flex-column justify-content-center`}
      role="button"
      onBlur={onBlur}
      onMouseLeave={onMouseLeave}
      tabIndex="-1"
    >
      <p className={classNames('font-weight-bold', 'snf-font-14', 'm-0', { 'mb-1': phone })}>
        <MapPin className="mr-1" alt="Sistemi Informativi S.r.l. - An IBM company Linkedin" />
        <a
          href={`http://maps.google.com/?q=${indirizzo} – ${cap}`}
          className={`snf-text-color-prussian-blue d-inline-block ${styles.font} `}
          rel="noreferrer"
          target="_blank"
        >
          {indirizzo} – {cap}
        </a>
      </p>
      <div>
        {phone ? (
          <span className="d-inline-block">
            <FormattedMessage
              defaultMessage="Tel. "
              description="Sistemi Informativi label phone"
            />
            &nbsp;
            <a href={`tel:${phone}`} className="snf-text-color-prussian-blue d-inline-block">
              <p className="snf-font-13 m-0">{phone}</p>
            </a>
          </span>
        ) : null}
      </div>
      <div>
        {email ? (
          <span className="d-inline-block mt-1">
            <a href={`mailto:${email}`} className="snf-text-color-prussian-blue d-inline-block">
              <p className="snf-font-13 m-0">{email}</p>
            </a>
          </span>
        ) : null}
      </div>
    </div>
  );
};

TooltipContent.displayName = 'TooltipContent';
export { TooltipContent };
